import { render, staticRenderFns } from "./WY-PH-Notice.vue?vue&type=template&id=3711e250&scoped=true&"
import script from "./WY-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./WY-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./WY-PH-Notice.vue?vue&type=style&index=0&id=3711e250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3711e250",
  null
  
)

export default component.exports